<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1000 1000"
    enable-background="new 0 0 1000 1000"
    xml:space="preserve"
  >
    <g>
      <g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)">
        <path
          d="M6305,2312.1V500.7h1797.5H9900v167.9c0,1066.7-523.4,2105.7-1382.7,2749.6c-563,422.7-1216.8,653.8-1957.5,691.4l-254.8,11.8V2312.1z M7065.4,3758c1357-268.6,2407.9-1436,2530.4-2806.9l13.8-154.1H8104.4H6601.2v1513.1v1513.1l134.3-13.8C6808.7,3801.5,6956.8,3777.8,7065.4,3758z"
        />
        <path
          d="M5348.9,3837c-788.2-83-1586.2-438.5-2194.6-979.8l-197.5-175.8l-124.4,73.1c-69.1,41.5-203.4,98.8-296.3,130.4c-154.1,49.4-199.5,55.3-428.7,55.3c-292.3,0-432.6-29.6-653.8-138.3c-403-195.6-689.4-555.1-800-997.5c-35.6-140.2-41.5-203.5-31.6-404.9c5.9-138.3,23.7-282.5,43.5-345.7c90.9-290.4,280.5-570.9,521.5-760.5l122.5-98.8l-94.8-11.9C942,147.1,689.2,20.7,485.7-184.7C317.8-350.6,179.5-605.4,132.1-832.6c-41.5-201.5-43.5-2769.4-2-2850.4c35.6-67.2,100.7-126.4,189.6-173.8c65.2-35.6,152.1-37.5,1718.5-43.5c1064.7-4,1683,2,1742.2,15.8c173.8,35.5,288.4,142.2,306.2,278.5c5.9,41.5,11.8,77.1,13.8,77.1c2,0,75.1-29.6,163.9-67.2c1307.7-553.1,2808.9-333.8,3926.9,570.9c888.9,719,1432.1,1844.9,1432.1,2972.8v177.8H7756.8H5890.1v1866.7v1866.7l-191.6-2C5591.9,3854.8,5435.8,3846.9,5348.9,3837z M5593.8,1695.8V-170.9h1866.7h1866.7V-242c0-96.8-55.3-464.2-90.9-610.4c-169.9-683.5-513.6-1276-1019.3-1758c-274.6-262.7-519.5-434.6-865.2-608.4c-782.2-393.1-1613.8-489.9-2459.2-282.5c-241,59.3-369.4,104.7-612.3,209.4l-185.7,83l-5.9,1187.1l-5.9,1189.1l-53.3,144.2c-171.8,474.1-574.8,811.9-1037,869.1l-112.6,13.8l100.7,75.1c239,175.8,440.5,454.3,533.3,734.8c67.2,207.4,84.9,580.7,37.5,788.1c-43.5,179.8-162,428.6-276.5,572.8c-106.7,138.3-118.5,112.6,156,343.7c458.3,385.2,1001.5,653.8,1566.4,774.3c203.5,43.5,401,73.1,523.5,77l73.1,2V1695.8z M2358.3,2632.1c197.5-39.5,422.7-165.9,576.8-322c243-243,355.6-513.6,355.6-851.4c2-1033.1-1242.5-1578.3-1995.1-875.1c-258.8,243-385.2,525.4-387.2,865.2c0,221.2,25.7,335.8,114.6,525.4c152.1,322,430.6,555.1,780.2,647.9C1931.6,2657.8,2214.1,2661.7,2358.3,2632.1z M3051.6-121.5c327.9-84.9,596.5-343.7,709.1-679.5c43.5-128.4,45.4-150.1,51.3-1434.1l5.9-1303.7l-43.5-33.6c-39.5-33.6-148.1-35.5-1671.1-35.5c-1084.4,0-1641.5,5.9-1667.1,19.7c-35.6,19.7-37.5,55.3-37.5,1331.3c0,1145.7,4,1321.5,31.6,1416.3c106.7,355.6,373.3,630.1,701.2,717C1289.7-80,2889.7-78,3051.6-121.5z"
        />
      </g>
    </g>
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "SegmentationIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
